import { createComponent } from '@lair-finance/util'
import { Dialog, DialogContent, DialogOverlay, DialogPortal } from '@/shared/ui/Dialog'
import { useState } from 'react'
import * as React from 'react'
import { AgreementStorage } from '@/features/agreement/utils/storage.ts'
import { AgreementContent } from '@/features/agreement/components/AgreementModal/AgreementContent.tsx'
import { AgreeCheckButton } from '@/features/agreement/components/AgreementModal/AgreeCheckButton.tsx'
import { AgreeButton } from '@/features/agreement/components/AgreementModal/AgreeButton.tsx'

export const AgreementModal = createComponent<HTMLDivElement, React.ComponentPropsWithoutRef<typeof Dialog>>((props, ref) => {
  const [open, setOpen] = useState(!AgreementStorage.get())
  const [isAgree, setIsAgree] = useState(false)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent title={'Terms and Conditions'} className={'sm:max-w-[488px]'} onInteractOutside={e => e.preventDefault()} ref={ref} {...props}>
          <AgreementContent className={'mb-4 sm:mb-6'} />
          <AgreeCheckButton className={'mb-4 sm:mb-6'} checked={isAgree} onCheck={() => setIsAgree(prev => !prev)} />
          <AgreeButton disabled={!isAgree} onClick={() => setOpen(false)} />
        </DialogContent>
      </DialogPortal>
    </Dialog>
  )
}, 'AgreementModal')
